import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Nebraska Non-Profit State Filing Requirements & Deadlines"
          description="Learn Nebraska’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state. "
          keywords=" "
          canonical="nonprofit-taxes/nebraska-state-filing-requirements/"
          // jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ne-landing-img.webp" />
                <source srcSet="/assets/images/1099-ne-landing-img.png" />
                <img
                  src="/assets/images/1099-ne-landing-img.png"
                  alt="Nebraska State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Nebraska State </span>
                </span>{' '}
                Filing
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Operating a nonprofit organization in Nebraska involves adhering
                to specific state filing requirements to maintain compliance and
                good standing.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=nebraska`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ne-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-ne-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-ne-landing-img-sm.png"
                  alt="Nebraska State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Nebraska are required to complete several forms as
            part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.nebraska.gov/apps-sos-edocs/"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Articles of Incorporation - eDelivery
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.nebraska.gov/sites/default/files/doc/business-services/Corporations/Forms/ApplicationforReservationCorp.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Application for Reserved Name
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.nebraska.gov/sites/default/files/doc/business-services/Corporations/Forms/NPChangeofAgentOffice.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Change of Registered Agent/Office
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.nebraska.gov/business-services/annualbiennial-reporting"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Biennial Report
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.nebraska.gov/sites/default/files/doc/business-services/Corporations/Forms/AmendedBiennialReportNP.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Amendment or Correction to Non-Profit
                                Corporation Biennial Report
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://revenue.nebraska.gov/sites/default/files/doc/tax-forms/f_4.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 4 - Nebraska Exemption Application for
                                Sales and Use Tax
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://revenue.nebraska.gov/sites/default/files/doc/tax-forms/f_20.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 20 - Nebraska Tax Application
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://revenue.nebraska.gov/sites/default/files/doc/tax-forms/f_50.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 50 - Nebraska Application for Bingo,
                                Lottery, Raffle, or Lottery by Pickle Card
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              Form 1023 (Application for Recognition of
                              Exemption Under Section 501(c)(3) of the Internal
                              Revenue Code): For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              Form 1024 (Application for Recognition of
                              Exemption Under Section 501(a) or Section 521 of
                              the Internal Revenue Code): For other types of
                              nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Form 990 (Return of Organization Exempt From
                                Income Tax)
                              </Link>{' '}
                              : Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Nebraska nonprofits must meet both state and federal
                requirements. At the state level, the Secretary of State
                oversees incorporation, while the Department of Revenue manages
                tax matters.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                Key Requirements:
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <span style={{ fontWeight: 600 }}> Legal Formation</span> -
                  File Articles of Incorporation with the Nebraska Secretary of
                  State.
                </li>

                <li>
                  <span style={{ fontWeight: 600 }}> Registered Agent </span> -
                  Appoint an agent to receive official state notices.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> EIN</span> - Obtain an
                  Employer Identification Number for tax exemption, banking, and
                  hiring.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Federal Tax Exemption
                  </span>{' '}
                  - Apply for 501(c)(3) status with the IRS to receive
                  tax-deductible donations.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> State Tax Exemption</span>{' '}
                  - Apply for sales, use, income, and property tax exemptions.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Charitable Solicitation Registration{' '}
                  </span>{' '}
                  - Register with the Attorney General if soliciting donations
                  (some exceptions apply).
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>Annual Reporting </span> -
                  File an annual report with the Secretary of State to maintain
                  good standing.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-ne-img.webp" />
                <source srcSet="/assets/images/who-file-ne-img.png" />
                <img
                  src="/assets/images/who-file-ne-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#fff',
                  maxWidth: 850,
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Nebraska</span>,
                    organizations must:
                    <Box
                      component="ul"
                      sx={{
                        listStyleType: 'none',
                        paddingLeft: 0,
                        textAlign: 'left',
                        ml: { xs: 0, sm: 3 },
                        '& li svg': { float: 'left', fontSize: 27 },
                      }}
                    >
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        Must obtain{' '}
                        <span style={{ fontWeight: 600 }}>
                          Federal 501(c)(3) Status
                        </span>{' '}
                        and IRS determination letter is required.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        Apply to the Nebraska Department of Revenue for a sales
                        tax exemption using
                        <Hidden smDown>
                          {' '}
                          <br />
                        </Hidden>
                        Form 4 - Nebraska Exemption Application for Sales and
                        Use Tax
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}> Annual Filing:</span>{' '}
                        File Form 990 with the IRS.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        Register with the{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Nebraska Secretary of State
                        </span>{' '}
                        as a nonprofit entity.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        May need to register for charitable solicitations
                        depending on activities.
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in Nebraska:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Nebraska Secretary of State Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Before establishing the non-profit entity
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Charitable Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed before any solicitation activities begin
                          in Nebraska.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Biennial Report
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by April 1st of every odd-numbered year;
                          considered delinquent after June 16th.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Nebraska Department of Revenue Forms Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Nebraska Tax Application (Form 20)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Filed upon formation or when the non-profit begins
                          activities that trigger a tax registration requirement
                          (e.g., hiring employees, making taxable sales).
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Application for Sales Tax Exemption
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            borderBottom: '1px solid #828282',
                          }}
                        >
                          Filed once when initially applying for the exemption.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Application for Bingo, Lottery, or Lottery by Pickle
                          Card (Form 50)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be submitted at least 45 days prior to the
                          expiration date of the license, unless the application
                          applies only to limited period bingo or the sale of
                          pickle cards at a special function.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends
                          <br />
                          <span style={{ fontWeight: 600 }}> Example:</span> For
                          calendar year organizations, Form 990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=nebraska`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Nebraska, organizations must
            file{' '}
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>
            the{' '}
            <span style={{ fontWeight: 600 }}>
              {' '}
              Articles of Corporation
            </span>{' '}
            with the Secretary of the State and pay the $25 filing fee.
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Initial Registration
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    The first crucial step in forming a non-profit is to legally
                    incorporate the entity with the Nebraska Secretary of State.
                    Select a name for your non-profit that complies with
                    Nebraska naming regulations.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Initial Organizational Meeting
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After the Articles of Incorporation are filed and the
                    non-profit is legally formed; the next step typically
                    involves holding an initial organizational meeting of the
                    board of directors.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Appointing a Registered Agent
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Every Nebraska non-profit corporation is required to have a
                    registered agent. This agent serves as the official point of
                    contact for receiving legal and official notices from the
                    state on behalf of the organization.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Obtaining an EIN
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After incorporating with the state, you will need to obtain
                    an Employer Identification Number (EIN) from the IRS.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Keep Records
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0 }}>
                    Maintain accurate and up-to-date records of your
                    organization’s finances, activities, and filings.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Filing Annual Report
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After initial registration, non-profits must file an annual
                    report to renew their charitable registration. File the
                    annual report with the Nebraska Secretary of State by April
                    1<sup>st</sup>.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Application for Sales Tax Exemption
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Sales tax exemption does not require renewal, but
                    organizations must keep their information up to date.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    If registered for state taxes (like employer withholding or
                    sales tax), file required periodic returns with the Nebraska
                    Department of Revenue (e.g., quarterly or annual withholding
                    reports, sales tax returns) as per your registration
                    requirements.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Filing IRS Form 990
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After receiving the exemption, you must file Form 990
                    annually (or Form 990-N if your gross receipts are typically
                    $50,000 or less). Failure to file for 3 consecutive years
                    will automatically revoke your 501(c)(3) status.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Charitable Organization Registration
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0 }}>
                    If soliciting donations, register with the Attorney General
                    before starting any fundraising activities.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          User-Friendly Nonprofit Filing Services
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone simplifies annual IRS filing for tax-exempt organizations.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=nebraska`}
          >
            Get started with TaxZerone
          </Button>
        </Box> */}
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Are there publication requirements for newly formed
                  nonprofits in Nebraska?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> Yes</b>. After filing Articles of Incorporation,
                    nonprofits must publish a notice of incorporation in a
                    local, legal newspaper for three consecutive weeks. The
                    newspaper must circulate in the county where the
                    nonprofit&apos;s registered office is located.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How can a nonprofit reinstate its status after
                  administrative dissolution?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      To reinstate, the organization must file an Application
                      for Reinstatement with the Nebraska Secretary of State and
                      pay the associated fee. Due to high call volumes,
                      it&apos;s recommended to email{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        sos.corp@nebraska.gov
                      </span>{' '}
                      to request the form.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How much does it cost to form a nonprofit in Nebraska?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      The cost to form a nonprofit in Nebraska involves state
                      filing fees and potential IRS fees for federal tax
                      exemption. The state filing fee for Articles of
                      Incorporation is $10 plus $5 per page. Additionally,
                      applying for federal 501(c) status can cost $275 or $600,
                      according to the IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Are all nonprofits required to register as charitable
                  organizations?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      <b>No</b>, only organizations that solicit charitable
                      contributions in Nebraska need to register as charitable
                      organizations. Some exceptions exist for religious
                      organizations, educational institutions, and certain small
                      nonprofits.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Does filing the Biennial Report also satisfy IRS filing
                  requirements?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      <b>No</b>. The Biennial Report is a state requirement for
                      maintaining your corporate registration. You must
                      separately file the appropriate IRS Form 990 series return
                      annually to maintain your federal <br /> tax-exempt
                      status.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://sos.nebraska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Nebraska Secretary of State
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://revenue.nebraska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Nebraska Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://dol.nebraska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Nebraska Department of Labor
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://ago.nebraska.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Nebraska Attorney General’s Office
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://sos.nebraska.gov/business-services/forms-and-fee-information"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Nebraska Secretary of State - Forms and Fee
                          Information
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Services
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
